<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <div id="map"></div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
var marker;
export default {
  props: ["reportData"],
  data() {
    return {
      report: null,
      map: null,
      showBack: false,
      ServerError: false,
    };
  },
  mounted() {
    this.report = this.reportData;
    if (this.report) this.loadMap();
  },
  methods: {
    loadMap() {
      var mapCanvas = document.getElementById("map");
      var mapOptions = {
        center: new google.maps.LatLng(
          this.report.location[1],
          this.report.location[0]
        ),
        zoom: 17,
        mapTypeId: google.maps.MapTypeId.HYBRID,
      };
      this.map = new google.maps.Map(mapCanvas, mapOptions);
      var latlngset = new google.maps.LatLng(
        this.report.location[1],
        this.report.location[0]
      );
      marker = new google.maps.Marker({
        map: this.map,
        position: latlngset,
      });
      this.oMarker = {
        m: marker,
        c: this.$route.params.id,
      };
    },
  },
};
</script>
<style scoped>
#map {
  height: 600px;
  width: 100%;
  margin: 0px;
  padding: 0px;
}
</style>